import { render, staticRenderFns } from "./_social.vue?vue&type=template&id=b12c5cc8&lang=pug&"
import script from "./_social.vue?vue&type=script&lang=js&"
export * from "./_social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports